import { IconWarning } from '@bolt/react-icon';

function Label({ displayType, className, children, hasErrors, ...otherProps }) {
  const classes = [];
  const userClasses = className ? className.split(' ') : [];

  if (userClasses.length) {
    classes.push(...userClasses);
  }

  switch (displayType) {
    case 'floating':
      classes.push('c-bolt-floating-label');
      break;
    case 'block':
      classes.push('c-bolt-block-label');
      if (hasErrors) {
        classes.push('c-bolt-block-label--invalid');
      }
      break;
    case 'inline-radio':
      classes.push('c-bolt-inline-label', 'c-bolt-inline-label--radio');
      break;
    case 'inline-checkbox':
      classes.push('c-bolt-inline-label', 'c-bolt-inline-label--checkbox');
      break;
    default:
      classes.push('c-bolt-floating-label');
  }

  return (
    <label className={classes.join(' ')} {...otherProps}>
      {displayType === 'block' && (
        <div className="c-bolt-input-icon--invalid">
          <IconWarning />
        </div>
      )}
      <span>{children}</span>
    </label>
  );
}

export default Label;
